var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { CreateAccountCommand, } from '../../../commands/accounts/create.account.command';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData, } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { SuccessWrapComponent } from '../../../common/components/success.wrap/success.wrap.component';
import { ModalService } from '../../../common/services/modal.service';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { AccountApiService } from '../../../services/account.api.service';
import { AccountUsersModalComponent } from './account.users/account.users.modal.component';
import { AccountUsersModalActions, AccountUsersModalData, } from './account.users/account.users.modal.provider';
import { EventSpiderModalComponent } from './event.spider/event.spider.modal.component';
import { EventSpiderModalData, EventSpiderModalActions, } from './event.spider/event.spider.modal.provider';
import { ShowInfoModalComponent } from '../../hub/show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions, } from '../../hub/show.info.modal/show.info.modal.provider';
import { SetApprovedComponent } from './set.approved/set.approved.component';
import { SetContactsModalComponent } from './set.contacts/set.contacts.modal.component';
import { SetContactsModalActions, SetContactsModalData, } from './set.contacts/set.contacts.modal.provider';
import { SetPlaceSourceModalComponent } from './set.place.source/set.place.source.modal.component';
import { SetPlaceSourceModalData, SetPlaceSourceModalActions, } from './set.place.source/set.place.source.modal.provider';
import { ShowPlacesCountModalComponent } from './show.places.count/show.places.count.modal.component';
import { ShowPlacesCountModalActions, ShowPlacesCountModalData, } from './show.places.count/show.places.count.modal.provider';
import { ToggleFeaturesModalComponent } from './toggle.features/toggle.features.modal.component';
import { ToggleFeaturesModalActions, ToggleFeaturesModalData, } from './toggle.features/toggle.features.modal.provider';
import { ToggleIsClientModalComponent } from './toggle.is.client/toggle.is.client.modal.component';
import { ToggleIsClientModalActions, ToggleIsClientModalData, } from './toggle.is.client/toggle.is.client.modal.provider';
import { SetIgVersionModalComponent } from './set.ig.version/set.ig.version.modal.component';
import { SetIgVersionModalActions, SetIgVersionModalData, } from './set.ig.version/set.ig.version.modal.provider';
import { TravelBuddySettingsModalComponent } from './travel.buddy.settings/travel.buddy.settings.modal.component';
import { TravelBuddySettingsModalActions, TravelBuddySettingsModalData, } from './travel.buddy.settings/travel.buddy.settings.modal.provider';
import { isNullOrUndefined } from '../../../common/extensions';
var AccountsComponent = /** @class */ (function () {
    function AccountsComponent(formBuilder, dialog, modalService, accountApiService) {
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.modalService = modalService;
        this.accountApiService = accountApiService;
        this.liveCount = 0;
        this.deadCount = 0;
        this.createAccountCommand = new CreateAccountCommand('', '');
    }
    AccountsComponent.prototype.ngOnInit = function () {
        this.createAccountFormGroup = this.formBuilder.group({
            userName: [null, [Validators.required]],
            password: [null, [Validators.required]],
        });
        this.fetchAccounts();
    };
    AccountsComponent.prototype.createAccount = function ($event) {
        var _this = this;
        this.accountApiService
            .createAccount(this.createAccountCommand)
            .finally($event.complete)
            .subscribe(function () {
            _this.createAccountCommand = new CreateAccountCommand('', '');
            _this.createAccountFormGroup.markAsPristine();
            _this.fetchAccounts();
        });
    };
    AccountsComponent.prototype.deleteAccount = function (account) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.accountApiService
                    .deleteAccount(account._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.fetchAccounts();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to delete this account?',
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    AccountsComponent.prototype.disableAccount = function (account) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.accountApiService
                    .disableAccount(account._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.fetchAccounts();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to disable this account, but you can enable it later?',
            confirmModalConfirmButtonText: 'Disable',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    AccountsComponent.prototype.enableAccount = function (account) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.accountApiService
                    .enableAccount(account._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.fetchAccounts();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to enable this account?',
            confirmModalConfirmButtonText: 'Enable',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    AccountsComponent.prototype.SetDefaultApproved = function (account) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            eventApproved: account.customSettings
                && account.customSettings.defaultSetting
                && account.customSettings.defaultSetting.event
                ? (isNullOrUndefined(account.customSettings.defaultSetting.event.isApproved)
                    ? false
                    : account.customSettings.defaultSetting.event.isApproved)
                : false,
            placeApproved: account.customSettings
                && account.customSettings.defaultSetting
                && account.customSettings.defaultSetting.place
                ? (isNullOrUndefined(account.customSettings.defaultSetting.place.isApproved)
                    ? true
                    : account.customSettings.defaultSetting.place.isApproved)
                : true,
            jobApproved: account.customSettings &&
                account.customSettings.defaultSetting &&
                !isNullOrUndefined(account.customSettings.defaultSetting.job)
                ? account.customSettings.defaultSetting.job.isApproved
                : true,
        };
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        var dialogRef = this.dialog.open(SetApprovedComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (data) {
            if (data) {
                _this.accountApiService
                    .SetDefaultApproved(account._id, data.eventApproved, data.placeApproved, data.jobApproved)
                    .subscribe(function () {
                    _this.fetchAccounts();
                });
            }
        });
    };
    AccountsComponent.prototype.getAPIKey = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var data, info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!account.apiKey || !account.apiKey.key)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accountApiService.setApiKey(account._id).toPromise()];
                    case 1:
                        data = _a.sent();
                        account.apiKey = data;
                        _a.label = 2;
                    case 2:
                        info = [];
                        info.push("<b>Key:</b> <input style=\"width:450px;height:30px\" value=\"" + account.apiKey.key + "\"></input>");
                        info.push("<b>JSON feed last request time:</b> " + account.apiKey.lastRequest.time + ", <b>with key:</b> " + (account.apiKey.lastRequest.isContainKey
                            ? '<span style="color:green">Yes</span>'
                            : '<span style="color:red">No</span>'));
                        this.modalService.show({
                            component: ShowInfoModalComponent,
                            providers: [
                                { provide: ShowInfoModalActions, useValue: null },
                                { provide: InfoModalData, useValue: new InfoModalData('API Key', 'attach_money', info) },
                            ],
                            panelClass: 'width-modal-4',
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountsComponent.prototype.changeIgVersion = function (account) {
        this.modalService.show({
            component: SetIgVersionModalComponent,
            providers: [
                { provide: SetIgVersionModalActions, useValue: new SetIgVersionModalActions() },
                { provide: SetIgVersionModalData, useValue: new SetIgVersionModalData(account) },
            ],
            panelClass: 'width-modal-4',
        });
    };
    AccountsComponent.prototype.travelBuddySettings = function (account) {
        this.modalService.show({
            component: TravelBuddySettingsModalComponent,
            providers: [
                {
                    provide: TravelBuddySettingsModalActions,
                    useValue: new TravelBuddySettingsModalActions(),
                },
                {
                    provide: TravelBuddySettingsModalData,
                    useValue: new TravelBuddySettingsModalData(account),
                },
            ],
            panelClass: 'width-modal-5',
        });
    };
    AccountsComponent.prototype.SetClientContacts = function (account) {
        if (!account.contacts) {
            account.contacts = {
                name: '',
                number: '',
                email: '',
                inquiryEmail: '',
            };
        }
        this.modalService.show({
            component: SetContactsModalComponent,
            providers: [
                { provide: SetContactsModalActions, useValue: new SetContactsModalActions() },
                { provide: SetContactsModalData, useValue: new SetContactsModalData(account) },
            ],
            panelClass: 'width-modal-70p',
        });
    };
    AccountsComponent.prototype.toggleClientAccount = function (account) {
        this.modalService.show({
            component: ToggleIsClientModalComponent,
            providers: [
                { provide: ToggleIsClientModalActions, useValue: new ToggleIsClientModalActions() },
                { provide: ToggleIsClientModalData, useValue: new ToggleIsClientModalData(account) },
            ],
        });
    };
    AccountsComponent.prototype.getPlaceCount = function (account) {
        this.modalService.show({
            component: ShowPlacesCountModalComponent,
            providers: [
                { provide: ToggleIsClientModalActions, useValue: new ShowPlacesCountModalActions() },
                { provide: ShowPlacesCountModalData, useValue: new ShowPlacesCountModalData(account) },
            ],
            panelClass: 'width-modal-70p',
        });
        // this.accountApiService.getPlaceCount(account.userName)
        //     .subscribe((count) => {
        //         if (count && !isNullOrUndefined(count.total) && !isNullOrUndefined(count.approved) && !isNullOrUndefined(count.unApproved)) {
        //             this.modalService.show({
        //                 component: ShowInfoModalComponent,
        //                 providers: [
        //                     {provide: ShowInfoModalActions, useValue: null},
        //                     {
        //                         provide: InfoModalData,
        //                         useValue: new InfoModalData(`Place Count for ${account.userName}`, [], [`Total place count: ${count.total}`, `<span style="color:green">Approved: ${count.approved}</span>`, `<span style="color:red">UnApproved: ${count.unApproved}</span>`])
        //                     }
        //                 ]
        //             });
        //         }
        //     });
    };
    AccountsComponent.prototype.setPlaceSource = function (account) {
        this.modalService.show({
            component: SetPlaceSourceModalComponent,
            providers: [
                { provide: SetPlaceSourceModalActions, useValue: new SetPlaceSourceModalActions() },
                { provide: SetPlaceSourceModalData, useValue: new SetPlaceSourceModalData(account) },
            ],
        });
    };
    AccountsComponent.prototype.showUsers = function (account) {
        this.modalService.show({
            component: AccountUsersModalComponent,
            providers: [
                { provide: AccountUsersModalActions, useValue: new AccountUsersModalActions() },
                { provide: AccountUsersModalData, useValue: new AccountUsersModalData(account.userName) },
            ],
            panelClass: 'width-modal-70p',
        });
    };
    AccountsComponent.prototype.eventSpider = function (account) {
        if (!account.toggle) {
            account.toggle = new HubVisitorFeatureToggle();
        }
        this.modalService.show({
            component: EventSpiderModalComponent,
            providers: [
                { provide: EventSpiderModalActions, useValue: new EventSpiderModalActions() },
                { provide: EventSpiderModalData, useValue: new EventSpiderModalData(account) },
            ],
            panelClass: 'width-modal-70p',
        });
    };
    AccountsComponent.prototype.toggleFeatures = function (account) {
        if (!account.toggle) {
            account.toggle = new HubVisitorFeatureToggle();
        }
        this.modalService.show({
            component: ToggleFeaturesModalComponent,
            providers: [
                { provide: ToggleFeaturesModalActions, useValue: new ToggleFeaturesModalActions() },
                { provide: ToggleFeaturesModalData, useValue: new ToggleFeaturesModalData(account) },
            ],
            panelClass: 'width-modal-1',
        });
    };
    AccountsComponent.prototype.showEventCount = function (account) {
        var _this = this;
        this.accountApiService.getEventCount(account.userName).subscribe(function (count) {
            var info = [
                "Total Approved Event Count: <b style=\"color:green\">" + count.approved + "</b>",
                "Total Unapproved Event Count: <b style=\"color:red\">" + count.unapproved + "</b>",
            ];
            var monthly = '', annual = {};
            if (count.spiderMonthlyCount && count.spiderMonthlyCount.length) {
                var monthText_1 = [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec',
                ];
                count.spiderMonthlyCount.forEach(function (x) {
                    if (x.month.indexOf('-') >= 0) {
                        var year = parseInt(x.month.split('-')[0], 10);
                        var monthIndex = parseInt(x.month.split('-')[1], 10) - 1;
                        var monthTitle = monthText_1[monthIndex] + "." + x.month.split('-')[0];
                        var total = x.facebook + x.eventbrite + (x.serpGoogle || 0) - (x.similarCount || 0);
                        total = total < 0 ? 0 : total;
                        var approvedPer = (x.approvedCount || 0) >= total ? 100 : ((x.approvedCount || 0) / total) * 100;
                        var percentage = (approvedPer || 0).toFixed(0);
                        if (monthIndex === 0 || !annual[year]) {
                            annual[year] = {
                                facebook: x.facebook,
                                eventbrite: x.eventbrite,
                                serpGoogle: x.serpGoogle || 0,
                                approvedCount: {
                                    count: x.approvedCount || 0,
                                    rate: percentage + '%',
                                    monthly: monthTitle + ": <b>" + (x.approvedCount || 0) + "</b>, Total: <b>" + total + "</b>, Approval Rate: <b>" + percentage + "%</b><br>",
                                },
                                similarCount: x.similarCount || 0,
                                yearTotal: total,
                            };
                        }
                        else {
                            annual[year].facebook += x.facebook;
                            annual[year].eventbrite += x.eventbrite;
                            annual[year].serpGoogle += x.serpGoogle || 0;
                            annual[year].approvedCount.count += x.approvedCount || 0;
                            annual[year].similarCount += x.similarCount || 0;
                            var yearTotal = annual[year].facebook +
                                annual[year].eventbrite +
                                annual[year].serpGoogle -
                                annual[year].similarCount;
                            yearTotal = yearTotal < 0 ? 0 : yearTotal;
                            var rate = annual[year].approvedCount.count > yearTotal
                                ? 100
                                : (annual[year].approvedCount.count / yearTotal) * 100;
                            annual[year].approvedCount.rate = rate.toFixed(0) + '%';
                            annual[year].yearTotal = yearTotal;
                            annual[year].approvedCount.monthly += monthTitle + ": <b>" + (x.approvedCount || 0) + "</b>, Total: <b>" + total + "</b>, Approval Rate: <b>" + percentage + "%</b><br>";
                        }
                        monthly += monthTitle + ": <b>" + (x.facebook + x.eventbrite + (x.serpGoogle || 0)) + "</b> in all (Facebook: " + x.facebook + ", Eventbrite: " + x.eventbrite + ", SerpGoogle: " + (x.serpGoogle || 0) + ", similar: " + (x.similarCount || 0) + ")<br>";
                    }
                });
                info.push("<span style=\"color:mediumblue;cursor:pointer\" onclick=\"var countwrap=document.getElementById('countwrap');countwrap.style.visibility=countwrap.style.visibility==='hidden'?'visible':'hidden';countwrap.style.height=countwrap.style.height==='0px'?'auto':'0px'\">Show monthly accumulated quantity</span>");
                info.push("<div id=\"countwrap\" style=\"visibility: hidden;height:0px\">" + monthly + "</div>");
            }
            info.push.apply(info, [
                '<br/>',
                "<b>Facebook Event Count</b>",
                "Total Approved Event Count: <b style=\"color:green\">" + count.fbPage.approved + "</b>, Total Unapproved Event Count: <b style=\"color:red\">" + count.fbPage.unapproved + "</b>",
            ]);
            if (count.lastRunTime && count.lastRunTime.facebookLastRunTime) {
                var time = new Date(count.lastRunTime.facebookLastRunTime);
                info.push("Last Run Time: <b>" + time.toLocaleString() + "</b>");
            }
            for (var _i = 0, _a = count.fbPage.pages; _i < _a.length; _i++) {
                var page = _a[_i];
                info.push(page.url + ": <b>" + (page.lastRunTime ? new Date(page.lastRunTime).toLocaleString() : 'N/A') + "</b>, New events pulled: <b>" + (page.newEventsPulledInLastRun || 0) + "</b>, Existed Events: <b>" + (page.existedEventPulledInLastRun || 0) + "</b><br>");
            }
            // info.push('<b>Facebook partners with no events:</b>');
            // for (let page of count.fbPage.noEventPages) {
            //   info.push(`${page}`);
            // }
            // let pageLastRunTime = '';
            // count.fbPage.pages.forEach((x) => {
            //   pageLastRunTime += `${x.url}: <b>${x.lastRunTime ? new Date(x.lastRunTime).toLocaleString() : 'N/A'}</b><br>`;
            // });
            // info.push(
            //   `<span style="color:mediumblue;cursor:pointer" onclick="var lastRunTimeByPage=document.getElementById('lastRunTimeByPage');lastRunTimeByPage.style.visibility=lastRunTimeByPage.style.visibility==='hidden'?'visible':'hidden';lastRunTimeByPage.style.height=lastRunTimeByPage.style.height==='0px'?'auto':'0px'">Show last run time for each page</span>`
            // );
            // info.push(`<div id="lastRunTimeByPage" style="visibility: hidden;height:0px">${pageLastRunTime}</div>`);
            info.push('<br/>');
            info.push("<b>Eventbrite Event Count</b>");
            info.push("Total Approved Event Count: <b style=\"color:green\">" + count.eventbritePage.approved + "</b>, Total Unapproved Event Count: <b style=\"color:red\">" + count.eventbritePage.unapproved + "</b>");
            if (count.lastRunTime && count.lastRunTime.eventbriteLastRunTime) {
                var time = new Date(count.lastRunTime.eventbriteLastRunTime);
                info.push("Last Run Time: <b>" + time.toLocaleString() + "</b>");
            }
            // for (let page in count.eventbritePage.eventByPage) {
            //   if (count.eventbritePage.eventByPage[page]) {
            //     info.push(`${page}: <b>${count.eventbritePage.eventByPage[page].length}</b>`);
            //   }
            // }
            for (var _b = 0, _c = count.eventbritePage.pages; _b < _c.length; _b++) {
                var page = _c[_b];
                info.push(page.url + ": <b>" + (page.lastRunTime ? new Date(page.lastRunTime).toLocaleString() : 'N/A') + "</b>, New events pulled: <b>" + (page.newEventsPulledInLastRun || 0) + "</b>, Existed Events: <b>" + (page.existedEventPulledInLastRun || 0) + "</b><br>");
            }
            var pageLastRunTimeEventbrite = '';
            count.eventbritePage.pages.forEach(function (x) {
                pageLastRunTimeEventbrite += x.url + ": <b>" + (x.lastRunTime ? new Date(x.lastRunTime).toLocaleString() : 'N/A') + "</b><br>";
            });
            // info.push(
            //   `<span style="color:mediumblue;cursor:pointer" onclick="var pageLastRunTimeEventbrite=document.getElementById('pageLastRunTimeEventbrite');pageLastRunTimeEventbrite.style.visibility=pageLastRunTimeEventbrite.style.visibility==='hidden'?'visible':'hidden';pageLastRunTimeEventbrite.style.height=pageLastRunTimeEventbrite.style.height==='0px'?'auto':'0px'">Show last run time for each page</span>`
            // );
            // info.push(
            //   `<div id="pageLastRunTimeEventbrite" style="visibility: hidden;height:0px">${pageLastRunTimeEventbrite}</div>`
            // );
            // info.push('<br/>');
            // info.push(`<b>Eventful Event Count</b>`);
            // info.push(
            //   `Total Approved Event Count: <b style="color:green">${count.eventful.approved}</b>, Total Unapproved Event Count: <b style="color:red">${count.eventful.unapproved}</b>`
            // );
            info.push('<br/>');
            info.push("<b>Serp Google Event Count</b>");
            info.push("Total Approved Event Count: <b style=\"color:green\">" + count.serpGoogle.approved + "</b>, Total Unapproved Event Count: <b style=\"color:red\">" + count.serpGoogle.unapproved + "</b>");
            if (count.lastRunTime && count.lastRunTime.serpGoogleLastRunTime) {
                var time = new Date(count.lastRunTime.serpGoogleLastRunTime);
                info.push("Last Run Time: <b>" + time.toLocaleString() + "</b>");
            }
            for (var _d = 0, _e = count.serpGoogle.pages; _d < _e.length; _d++) {
                var page = _e[_d];
                info.push(page.url + ": <b>" + (page.lastRunTime ? new Date(page.lastRunTime).toLocaleString() : 'N/A') + "</b>, New events pulled: <b>" + (page.newEventsPulledInLastRun || 0) + "</b>, Existed Events: <b>" + (page.existedEventPulledInLastRun || 0) + "</b><br>");
            }
            info.push('<br/>');
            info.push("<b>Annual Count</b>");
            for (var key in annual) {
                if (annual[key]) {
                    var total = annual[key].facebook + annual[key].eventbrite + (annual[key].serpGoogle || 0);
                    info.push("<b>" + key + "</b>: Facebook: " + annual[key].facebook + ", Eventbrite: " + annual[key].eventbrite + ", SerpGoogle: " + (annual[key].serpGoogle || 0) + ", similar: " + (annual[key].similarCount || 0) + ", <b>TOTAL: " + total + " - " + (annual[key].similarCount || 0) + " = " + (total - (annual[key].similarCount || 0)) + "</b>");
                }
            }
            info.push('<br/>');
            info.push("<b>Approval Count</b>");
            for (var key in annual) {
                if (annual[key]) {
                    info.push("<span style=\"color:mediumblue;cursor:pointer\" onclick=\"var monthly=document.getElementById('monthly-approved-count-" + key + "');monthly.style.visibility=monthly.style.visibility==='hidden'?'visible':'hidden';monthly.style.height=monthly.style.height==='0px'?'auto':'0px';monthly.style.overflow=monthly.style.overflow==='hidden'?'visible':'hidden'\">" + key + "</span>: Total approved count: \n            <b>" + (annual[key].approvedCount.count || 0) + "</b>, Total: <b>" + annual[key].yearTotal + "</b>, Approval Rate: <b>" + annual[key].approvedCount.rate + "</b>");
                    info.push("<div id=\"monthly-approved-count-" + key + "\" style=\"visibility: hidden;height:0px;overflow:hidden;margin-left: 19px\">" + annual[key].approvedCount.monthly + "</div>");
                }
            }
            console.log('annual', annual);
            _this.modalService.show({
                component: ShowInfoModalComponent,
                providers: [
                    { provide: ShowInfoModalActions, useValue: null },
                    {
                        provide: InfoModalData,
                        useValue: new InfoModalData('Event Count - ' + account.userName, null, info),
                    },
                ],
                panelClass: 'width-modal-6',
            });
        });
    };
    AccountsComponent.prototype.menuBar = function (account, setToNormal) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.accountApiService
                    .setMenuBar(account._id, setToNormal)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.fetchAccounts();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to set the menu bar to " + (setToNormal ? 'normal' : 'simple') + " style for this account?",
            confirmModalConfirmButtonText: 'Yes',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    AccountsComponent.prototype.fetchAccounts = function () {
        var _this = this;
        this.accountApiService.getAccounts().subscribe(function (accounts) {
            _this.accounts = accounts;
            _this.liveCount = accounts.filter(function (x) { return x.status === 'live' && !x.isAdministrator; }).length;
            _this.deadCount = accounts.filter(function (x) { return x.status === 'dead'; }).length;
        });
    };
    return AccountsComponent;
}());
export { AccountsComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/accounts.component.ts.pre-build-optimizer.js